import { observer } from 'mobx-react-lite'
import { Typography } from 'shared/ui'
import styles from './styles.module.scss'

export const ActionsTab = observer(() => {
  return (
    <div className={styles.tabContent}>
      <Typography ariaLabel={'successAction'} variant={'body-rg-medium'}>
        Success
      </Typography>
    </div>
  )
})
